import { useSelector, useDispatch } from 'react-redux';
import FJMobileGenerateStatus from './FJMobileGenerateStatus';
import FJActionCommon from '../../../redux/action/FJActionCommon';
import { useCallback, useMemo } from 'react';
import FJAppConstant from '../../../constants/FJAppConstant';
const FJMobileGenerateStatusContainer = () => {
    const dispatch = useDispatch();
    const taskStatus = useSelector(state => state.common.taskStatus);
    const progress = useSelector(state => state.common.progress);
    const currentQueue = useSelector(state => state.common.currentQueue);
    const queueNumber = useSelector(state => state.common.queueNumber);
    const appType = useSelector(state => state.common.appType);
    const onCancel = useCallback(() => {
        dispatch(FJActionCommon.cancelTaskAction());
    }, [dispatch]);
    const isHideCancelBtn = useMemo(() => {
        return appType === FJAppConstant.IMAGE_TO_IMAGE || appType === FJAppConstant.TEXT_TO_IMAGE;
    }, [appType]);
    return (
        <FJMobileGenerateStatus
            taskStatus={taskStatus}
            onCancel={isHideCancelBtn ? null : onCancel}
            progress={progress}
            currentQueue={currentQueue}
            queueNumber={queueNumber}
        />
    );
};
export default FJMobileGenerateStatusContainer;
